import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const TypesOfBirthsOnPreviosPregnancies = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();

    return (
        <Donut
            title={'Tipos de Partos em Gestações Anteriores'}
            subtitles={chartData?.typesOfBirthsOnPreviosPregnancies?.map((item) => item.description)}
            chartData={chartData?.typesOfBirthsOnPreviosPregnancies || []}
            colors={defaultColors.slice(0, chartData?.typesOfBirthsOnPreviosPregnancies?.length) || []}
            height={350}
            className='aligned-container'
        />
    );
};
